import gql from "graphql-tag";

// Site Fragment
const SiteProps = gql`
	fragment SiteProps on Site {
		id
		name
		logo
		address
		email
		website
		tel
		created_at
		type {
			id
			name
		}
	}
`;
//  Get a single site
const GET_SITE = gql`
	query GetSingleSite($id: ID!) {
		GetSite(id: $id) {
			doc {
				...SiteProps
			}
		}
	}
	${SiteProps}
`;
const SITE_SIBLINGS = gql`
	query GetSiteSiblings($parent: ID!) {
		GetSiblingSites(parent: $parent) {
			docs {
				...SiteProps
			}
		}
	}
	${SiteProps}
`;
export { GET_SITE, SITE_SIBLINGS };
